import { _ as _async_to_generator } from "@swc/helpers/_/_async_to_generator";
import { _ as _ts_generator } from "@swc/helpers/_/_ts_generator";
var pathContainsMaker = function(path) {
    return path.toLocaleLowerCase().includes("/maker") && !path.toLocaleLowerCase().includes("/makers");
};
var replaceMakerWithBrandInPath = function(path) {
    return path.replace(/maker/gi, "brand");
};
export var initializeBrandRedirects = /*#__PURE__*/ function() {
    var _ref = _async_to_generator(function(history) {
        var checkAndRedirectPath;
        return _ts_generator(this, function(_state) {
            // As of 24-03-2021 all paths containing the substring "maker" are renamed to contain "brand" and redirected accordingly
            checkAndRedirectPath = function(location, action) {
                if (action === "POP" || !pathContainsMaker(history.location.pathname)) {
                    return;
                }
                var pathname = location.pathname, search = location.search, hash = location.hash;
                var updatedUrl = replaceMakerWithBrandInPath(pathname);
                history.replace("".concat(updatedUrl).concat(search).concat(hash));
            };
            history === null || history === void 0 ? void 0 : history.listen(checkAndRedirectPath);
            // Check inital path for redirect as well
            checkAndRedirectPath(history.location, "PUSH");
            return [
                2
            ];
        });
    });
    return function initializeBrandRedirects(history) {
        return _ref.apply(this, arguments);
    };
}();
